export default {
  errors: {
    required: {
      id: 'marketplaceOrderForm.errors.required',
      defaultMessage: 'Please fill in the questionnaire.',
    },
  },
};
